(function ($, konto) {	
    var Unos = function (unique, options) {   	    	
        konto.KontoBase.call(this, unique);            
        var that = this;
        this.id = "unos-" + unique;
        this.form = $("#" + this.id);
        this.progress = false; //prikazivanje throbber (kotacica)
        this.preventRedirectOnSubmit = false; //defaultno
        this._rucnoPopunjavanje = false;
        
        this.dataObject = null;
        this.dataObjects = null;
        this.comboDataObject = null;
        this.isUpdate = this.sel("input[name=form-type]").val() == "update";
        this.novi = this.sel("input[name=form-type]").val() == "insert";
        this.postVersion = 1;
        var postVersionValue = (postVerInput = this.$("input[name='form-post-ver']")).length === 1 ? postVerInput.val() : "";
        if (postVersionValue !== "")
        	this.postVersion = parseInt(postVersionValue);
        
        //za fokus polja nakon popunjavanja elemenata
        this.afterPopuniElemente = $.Deferred();
        this.postaviBeforeVrijednosti = function(){};
        this.programskiIzlaz = false;
        this.doNotifyBeforePost = true;
        this.afterPopuniElemente.progress(function(){
            that.programskiIzlaz = false;
            that.postaviBeforeVrijednosti();
            if (that._focusedBefore)                                        
				that._focusedBefore.focus().select();
			if (!that.progress)
            	KUtils.busy(false);
        });
        
        $.extend(this, options);
        
        $("body").addClass("nonClickable");
        
        $("body").on("unosloaded." + this.unique, function () {
			if (that._rucnoPopunjavanje == true){
				//popunjavamo na unosu	
			}else{
	            // Stavljam vrijednosti u fieldove. Treba before initForme?
	            that.popuniElemente(that.dataObject);
	            
	            if (that.dataObjects) {
	            	for (model in that.dataObjects) {
	            		var object = that.dataObjects[model];
	            		if (object) {
	            			if (object.constructor === Array) {
	            				// not implemented
	            				if (object.length > 0) {
	            					var template = that.$("[data-model='" + object[0]["__typephp__"].replace(/\\/g, "\\\\") + "']");
	            					var root = template.attr("data-root");
	            					var collection = template.attr("data-collection");
	            					var $collection = that.$(collection);
	            					var html = template.html();
	            					
	            					for (var i = 0; i < object.length; ++i) {
	            						var compiledHtml = html.replace(/%index%/g, i);
	            						$collection.append(compiledHtml);
	            					}
	            					
	            					var initFunction = template.attr("data-init");
	            					var f = function () {};
	            					if (initFunction && typeof that[initFunction] === "function")
	            						f = that[initFunction];
	            					
	            					var elements = $collection.find(root);
	            					for (var i = 0; i < elements.length; ++i) {
	            						var $el = $(elements[i]);
	            						f($el);
	            						that.popuniElemente(object[i], undefined, undefined, $el);
	            					}
	            				}
	            			}
	            			else
	            				that.popuniElemente(object);
	            		}
	            	}
	            }
	            
	            //ajmo popuniti comboboxeve
	            if (that.comboDataObject) {
					that.sel('.combobox-group').each(function () {
		                that.popuniComboboxeve(that.comboDataObject, this);
		            });            			
	            }
            }
            
            if (that._ajaxAsync === true) {
            	that._ajaxQueue.start();
            }
            
            $("body").trigger("unos." + that.unique);
        });

        this.beforeLoaded(function () {
            // Sprečavam korištenje entera. Po poljima za unos se prolazi s tabom.
            // Defaultno enter znači upis stavke (nezgodno za one koji rade s našim desktop programima).
            that._overrideEnterBehaviour();
           
            // Sprečavam i korištenje backspace-a (ako je stavka disableana, 
            // onda bi se korisnik mogao zabuniti i stisnuti backspace
            // pa će izgubiti sve ostale podatke).
            that._overrideBackspaceBehaviour();  
           	
           	//TODO: ovo maknuti, rijesiti na bolji nacin... - Davor
           	//poseban slucaj, iliti iznimka... 
            that.sel(".btn-submit-addnew").click(function() {                
            	var ovoTrazim = this;	
			    $(function () {
				        function checkPendingRequest() { 
				            if ($.active > 0) { 
				                setTimeout(checkPendingRequest, 500);
				            }else{
				            	that.submitEvent(ovoTrazim, 'posao/unos'); 
				            }
				        };			
				        checkPendingRequest();
				});                
            });
            
            that.sel(".btn-apply").click(function() {                
            	var ovoTrazim = this;	
			    $(function () {
				        function checkPendingRequest() {
				            if ($.active > 0) { 
				                setTimeout(checkPendingRequest, 500);
				            }else{
				            	that.submitEvent(ovoTrazim, false);
				            }
				        };			
				        checkPendingRequest();
				});               
            });
            
            that.sel(".btn-submit").click(function () {
            	var ovoTrazim = this;	
			    $(function () {
				        function checkPendingRequest() {
				            if ($.active > 0) { 
				                setTimeout(checkPendingRequest, 500);
				            }else{
				            	that.submitEvent(ovoTrazim);
				            }
				        };			
				        checkPendingRequest();
				});        
    		});   	

            that.sel(".btn-odustani").click(function () {
                that.beforeOdustani();
                that.idiNatrag(null, true);
            });      
        });
            
        this.hookSubmitEvents('before', function() {
            if (that.progress) 
                KUtils.busy(); 
        });
       
        this.hookSubmitEvents('after', function() {
            if (that.progress) 
                KUtils.busy(false);
        });
    };
    
    konto.Unos = Unos;
    
    Unos.prototype = Object.create(konto.KontoBase.prototype);
    Unos.prototype.constructor = Unos;
    
    /**
     * Private
     */
    $.extend(Unos.prototype, {
        _getUnosFilter: function (filters) {
            var filter = {};
            filter.logic = "and";
            filter.filters = [];
            $.each(filters, function (key, value) {
                var f = {};
                f.operator = "contains";
                f.value = value;
                f.field = key;
                filter.filters.push(f);
            });
            return filter;
        },
        _focus: function ($el) {
            var checkValue = true;
            if (arguments.length > 1 && typeof arguments[1] === "boolean") {
                checkValue = arguments[1];
            }
			if (!$el.is( ":hidden" )){
	            if ($el.is("input")) {
	                if ((!checkValue || $el.val() == "" || $el.kval() == 0) && $el.prop("readonly") !== true && $el.prop("disabled") !== true) {
	                    $el.focus();
	                    return true;
	                }
	            }   
	            if ($el.is("select")) {
	                $el.focus();
	            }
            }
            return false;
        }
    });
    
    
    /**
     * Public
     */
    $.extend(Unos.prototype, {
        focusElements: function (el, startP, select, prvoPrazne) {
        	if (startP == undefined) startP = 0;
        	if (select == undefined) select = false;
        	if (prvoPrazne == undefined) prvoPrazne = true;
            var that = this;
            function elementIter(checkValue) {
                var focused = false;
                for (var i = startP; i < el.length; ++i) {
                    var $el = that.sel(el[i]);
                    if (that._focus($el, checkValue)) {
                    	if (select) $el.select();
                        focused = true;
                        break;
                    }
                }
                return focused;
            }
            if (typeof el === "string") {
                el = [el];
            }
            
            if ($.isArray(el)) {
                // Prvo probaj selektirati prvi element koji nema vrijednost.
                // Nakon toga probaj selektirati bilo koji element koji nije readonly
                // i disabled.
                if (prvoPrazne){
                	if (!elementIter(true)) {
                	    elementIter(false);   
                	}
                }else{
                	elementIter(false);	
                }
            }
        },
        
        focusFirstCanFocusControl: function(el){
        	//ako nije zadan redosljed nađe sve na formi (po redu) i fokusira prvu koju može!
        	if (el === undefined) el = $('form input:text').filter(':not(:hidden)').filter(":not(.skipEnterTab)").toArray();
        	this.focusElements(el,0,true,false);	
        },

        /**
         * Funkcija koja vraća Object Literal s key - value parovima gdje je
         * key - lowercase naziv polja kao u HTML (npr. fld-naziv, fld-datumpromjene)
         * value - jQuery input element
         */
        getInputElementsLiteral: function (clazz, $el) {
			var that = this;
            var selector;
            if (that.postVersion === 2)
            	selector = "[name*=\'data[" + clazz.replace(/\\/g, "\\\\") + "]']";
            else
            	selector = "[name*=\"fld" + (clazz ? ":" + clazz : "") + "-\"]";
            var els;
            if (typeof $el === "undefined")
             	els = that.$(selector);
             else 
             	els = $el.find(selector);
             	
            var inputs = {};
            $.each(els, function (index, el) {
                var name = el.name.toLowerCase();
                if (that.postVersion === 2) {
                	var arrayRegex = new RegExp("(data\\[" + clazz.toLowerCase().replace(/\\/g, "\\\\") + "\\])\\[\\d*\\](\\[.+)");
                	var matches = name.match(arrayRegex);
               		if (matches !== null && matches.length === 3) 
               			name = matches[1] + matches[2];
                } 
                
                var $el = $(el);
                if ($el.attr("type") == "radio") {
                    if (!inputs[name]) {
                        inputs[name] = {};
                        inputs[name].inputType = "radio";
                    }
                    inputs[name][$el.val()] = $el;
                }
                else {
                    inputs[name] = $el;
                }
            });
            return inputs;
        },
        
        /**
         * Popunjava comboboxeve u formi 
         */
        popuniComboboxeve: function (comboDataObjects, element) {
            var that = this;
            var cmbName = $(element).data('element-name');
            	cmbDataModel = cmbName.split('cmb')[1];
            
            if (!isset(cmbName)) {
            	cs ('Ne postoji naziv combobox elementa "element-name" !');
            	return;
            }
            
            if (isset(that[cmbName])) {
	        	for (model in comboDataObjects) 
	        		if (cmbDataModel == model) {
	        			
		        		var data = comboDataObjects[model];
		    			if (data.length > 0) {
	    					var cmb = that[cmbName];    				
			        			cmb.setDataSource(data);
			        			cmb.dataSource.read();
			        			cmb.refresh();
			        	}
					}
			} else {
				cs ('ne postoji combobox: '+cmbName);
			}
        	
        },
        /**
         * Ukoliko je bila sinkronizacija javlja prigodnu poruku. 
         */
        _sinkronizacijaAlertAkoTreba: function(chale, origObject){
        	var defaultSinkro = true;
        	if (chale.sinkronizacija) {
        		defaultSinkro = chale.sinkronizacija(origObject);	
        	}
        	if (defaultSinkro === true) {
            	var sinkro = origObject.__sinkro__;
            	var $alerts = chale.$(".alerts-container");
            	
            	if (sinkro.Error === true) {
            		konto.dialogs.alert({
            			root: $alerts,
            			content: "Upis nije moguć jer slog nije sinkroniziran s nadređenom jedinicom"
            		});	
            		
            		chale.$(".btn-submit").attr("disabled", true);
            	}
            	else if (sinkro.Refresh === true) {
            		konto.dialogs.alert({
            			root: $alerts,
            			content: "Slog je usklađen s nadređenom jedinicom"
            		});
            	}
            }	
        },
        /**
         * Puni elemente forme iz jedanog objekta na unosu v2 (postVersion === 2) 
         * Također kreira input za originalValues tog objekta.
         */
        _popuniElementeJednogObjekta_V2: function(obj, $el, delphiFieldsInKey, postaviOriginalValue){      	
        	var that = this;
			var inputs = that.getInputElementsLiteral(obj['__typephp__'], $el);
			var prefix = "data[" + obj['__typephp__'] + "]".toLowerCase();		
			var sinkronizacija = false;
			var originalValueObj = $.extend(true, {}, obj);
			var origObject = obj;
			
            if (typeof origObject === 'object' && origObject !== null && 
            	isset(origObject.__sinkro__) && origObject.__sinkro__ != null) 
            {
            	sinkronizacija = true;
            	delete originalValueObj.__sinkro__;
            }							
			if (postaviOriginalValue){
				var originalValueBaseEl = that.sel('input[name="fld-originalValues"]');				
				var originalVal = JSON.stringify(originalValueObj);	
				var originalValueObjektEL = $('<input type="hidden" name="'+  prefix +'[originalValues]" value="" />').val(originalVal);
				originalValueBaseEl.after(originalValueObjektEL);
			}		  		
    		if (obj){
    			if (postaviOriginalValue){
    				originalValueObjektEL.val(JSON.stringify(obj));	
    			}
				$.each(obj, function (key, value) {
					var name = (prefix + "[" + key.substring(delphiFieldsInKey ? 1 : 0).toLowerCase() + "]").toLowerCase();
					var field = inputs[name];
					if (!field)
						return;
					if (value !== null) {
	                    that.setElementValue(field, value);
	
	                    // Provjera za radio buttone.
	                    if (!(field.inputType == "radio")) {
	                        field.blur();
	                    }
	                }
	                else {
	                    // Clearanje elemenata je trenutno isključeno iz razloga jer se neki podaci postavljaju u Javascripti (defaultne vrijednosti)
	                    // Posljedično se te vrijednosti obrišu.
	                    //that.clearElementValue(field);
	                }
				});	
			}
			if (sinkronizacija) {
				that._sinkronizacijaAlertAkoTreba(that, origObject);
			}	
        },
        /**
         * Popunjava elemente forme iz objekta na "standradnom unosu tj. v1"
         */
        _popuniElementeUnos_V1: function(object, clazz, delphiFieldsInKey, $el, postaviOriginalValue){
        	var that = this;
            var sinkronizacija = false;
            var origObject = object;
            var originalValueEl = that.sel('input[name="fld-originalValues"]');
            var originalValue = $.extend(true, {}, object);	
                        
            if (typeof origObject === 'object' && origObject !== null && 
            	isset(origObject.__sinkro__) && origObject.__sinkro__ != null) 
            {
            	sinkronizacija = true;
            	delete originalValue.__sinkro__;
            }
            
            if (postaviOriginalValue){
            	originalValueEl.val(JSON.stringify(originalValue));
            }
            
            if (object) {
        	    if (postaviOriginalValue){
        			that.setElementValue(this.sel('input[name="fld-originalValues"]'), JSON.stringify(object));
        		}
            	
                var inputs = that.getInputElementsLiteral(clazz);
                $.each(object, function (key, value) {
                    var name = "fld" + (clazz ? ":" + clazz : "") + "-" + key.substring(delphiFieldsInKey ? 1 : 0).toLowerCase();
                    var field = inputs[name];
                    if (!field)
                        return;
                    
                    if (value !== null) {
                        that.setElementValue(field, value);
	
                        // Provjera za radio buttone.
                        if (!(field.inputType == "radio")) {
                            field.blur();
                        }
                    }
                    else {
                        // Clearanje elemenata je trenutno isključeno iz razloga jer se neki podaci postavljaju u Javascripti (defaultne vrijednosti)
                        // Posljedično se te vrijednosti obrišu.
                        //that.clearElementValue(field);
                    }
                });
            }
            if (sinkronizacija) {
            	that._sinkronizacijaAlertAkoTreba(that, origObject);
            }                     
        },
        /**
         * Popunjava elemente forme iz objekta.
         * Parametri:
         * object - objekt iz kojeg se pune inputi 
         * clazz  - klasa za koju se pune (potrebna kad imamo više različitih klasa na istoj formi)
         * postaviOriginalValue - potrebna FALSE vrijednost prilikom izvršavanja afterEvenata na unosu koji mjenjau podatke a dohvaćaju se iz DSa. 
         */
        popuniElemente: function (object, clazz, delphiFieldsInKey, $el, postaviOriginalValue) {
            if (typeof delphiFieldsInKey === "undefined") // arguments.count < 3
                delphiFieldsInKey = true;
            if (typeof postaviOriginalValue === "undefined")   
                postaviOriginalValue = true;

            var that = this;             
        	if (that.postVersion === 2) {
        		if (object){
	        		if (object.hasOwnProperty('__typephp__')){
	        			this._popuniElementeJednogObjekta_V2(object, $el, delphiFieldsInKey, postaviOriginalValue);	
	        		}else{
	            		$.each(object, function (key, value) {	
	            			that._popuniElementeJednogObjekta_V2(value, $el, delphiFieldsInKey, postaviOriginalValue);	
						});
	        		}	
        		}		
        	} else {
        		this._popuniElementeUnos_V1(object, clazz, delphiFieldsInKey, $el, postaviOriginalValue);
        	}           
           	this.afterPopuniElemente.notify();           
        },        
        /**
         * Briše inpute za navedenu klasu.
         */
        clear: function (clazz) {
            var inputs = this.getInputElementsLiteral(clazz);
            $.each(inputs, function (key, value) {
                this.clearElementValue(value);
            });
        },
        getOdustaniLink: function () {
            var izboriId = $("#izboriId").html(); 
            var izboriNewTabId = $('body').data('izboriNewTabId');                  
           	var sifarnikLinkName = "SifarnikLink_" + izboriId + '_' + izboriNewTabId;        	
        	var linkCache = KUtils.GetSifarnikLink(sifarnikLinkName);

            var lastLink = null;
            if (linkCache)
                lastLink = $.parseJSON(linkCache);
            var location = null;
            /**
             * Pitanje je da li treba biti relativna putanja ili apsolutna.
             * Promijenjeno u apsolutnu jer nije dovoljno ići samo na controller/action, 
             * već je moguće da postoje parametri.
             */
            if (lastLink)
                location = lastLink.link;
            if (!location)
                location = this.controller + "/pregled";
            return location;
        },
        getSuccessLink: function () {
            return this.getOdustaniLink();
        },
        getUrl: function () {
            return this.controller + "/" + this.baseActionName;
        },
        getPostData: function (form) {
            return form.serialize();
        },
        beforePost: function () {
        	
        },
        notifyBeforePost: function () {
        	
        },            
        afterPost: function (data) {
        	
        },   
        beforeOdustani: function () {
        	
        },     
        delayBeforePost: 0,                                
        submitEvent: function (button, redirect) {
        	var that = this;
        	
            if (typeof redirect === 'undefined')
                var redirect = true;
            
            //ako forsiramo override
            if (this.preventRedirectOnSubmit === true)
            	redirect = false;
                
           	that.$(".has-error").removeClass("has-error");
           	that.$(".has-warning").removeClass("has-warning");
            
            //nacin da stopiramo submit s beforePost funkcijom (return false)
            if (that.beforePost() === false)
            	return false;      
            
            that.fetchSubmitEvents('before');
            
            // Forma se uvijek POST-a preko Ajax-a. Razlog je pozivanje unosa
            // kao dialoga pa da se ne radi drugačije.
            var btn = $(button);
            var btnOdustani = that.sel(".btn-odustani");
            
            var btns = that.sel(".konto-form-btns .btn");
                btns.prop("disabled", true);
            
            var form = btn.closest("form");

        	var url = kontorouter.getModulPath(that.getUrl());       

            if(that.doNotifyBeforePost){
                that.notifyBeforePost();
            }

            setTimeout( function () { 
          
                $.ajax({
                    url: url,
                    type: "POST",
                    global: false,
                    data: that.getPostData(form),
                    dataType: "json",
                    errorTitle: "Obavijest"
                })
                    .done(function (data, textStatus, jqXHR) {
                        var object = data;
                        
                        if (data) {
                            simpleStorage.set('NewInsertedObject', data);  
                        }
                        else{
                            simpleStorage.deleteKey('NewInsertedObject');
                        }   

                        //var args = [data, textStatus, jqXHR];
                        that.fetchSubmitEvents('success', data); //, args);
                        //that.afterSubmitSuccessEvent(data, textStatus, jqXHR);                    
                        if (typeof redirect === 'boolean' && redirect){
                            that.idiNatrag(object);
                            that.afterPost(data);
                        }
                        else if (typeof redirect === 'string'){
                            kontorouter.goto(redirect);
                            that.afterPost(data);
                        }                 
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        KUtils.busy(false);
                        var success = false;
                        
                        try {
                            var json = JSON.parse(jqXHR.responseText);
                            json = JSON.parse(json.error);
                            if (("className" in json) && ("errors" in json)) {
                                success = true;	
                            }		
                        }
                        catch (e) {
                            
                        }
                        
                        if (success === true) {
                            that._obradiErrore(json);                		
                        }
                        else {
                            KUtils.defaultAjaxErrorHandler(null, jqXHR, this, errorThrown);
                        }
                    })
                    .always(function () {        
                            
                        that.fetchSubmitEvents('after');       
                        btns.prop("disabled", false);
                    });  
                
            }, that.delayBeforePost);  
        },
        idiNatrag: function(object, odustani) {        	
            if (typeof odustani !== "boolean")
                odustani = false;
            // Ajax može biti i ajax loadana forma u page-wrapper
            var ajaxHandled = false;
            if (this.isModal === true) {
                var p = this.form.closest("[data-role=kontomodal]");
                if (p.length > 0) {
                    var wnd = p.data("kendoKontoModal");
            
                    // Obavještavam da sam upisao.
                    if (object) {
                        this.form.trigger("onUpis", object);
                    }
                    wnd.close();
                    ajaxHandled = true;
                }
            }
            if (ajaxHandled !== true) {
                /**
                 * getSuccessLink kao parametar prima objekt jer je moguće da 
                 * će link ovisiti o objektu. Npr. stavke/pregled/<id_zaglavlja>
                 */
                var link = odustani ? this.getOdustaniLink() : this.getSuccessLink(object);
                /**
                 * Prije je bila provjera !this.isUpdate. Ali na update isto možemo mijenjati
                 * ključ, pa mi se čini da je jedina potrebna provjera da li je prenešen objekt.
                 */
                if (object) {
                    kontorouter.gotoPost(link, {
                        object: JSON.stringify($.dsObjectToJS(object))
                    });
                }
                else {
                    kontorouter.goto(link);
                }
            }
        },
        _obradiErrore: function (json) {
        	var that = this;
			var className = KUtils.delphiToPHPClassName(json.className);
			var prefix = "data[" + className.toLowerCase() + "]";
			
			var inputs = that.getInputElementsLiteral(className);
			var errors = $("<ul />");
			var hasErrors = false;
			var warnings = $("<ul />");
			var hasWarnings = false;
			var focused = false;
			json.errors.forEach(function (error) {
				var field = inputs[prefix + "[" + error.FColumnName.toLowerCase() + "]"];
				if (field) {
					field.closest(".form-group").addClass(error.FReturnType === "rtError" ? "has-error" : "has-warning");
					if (focused === false /* && error.FReturnType === "rtError" */) {
						field.focus();
						focused = true;
					}
				}
				if (error.FErrorMsg) {
					$("<li />", { text: error.FErrorMsg }).appendTo(errors);
					hasErrors = true;
				}
					
				if (error.FWarningMsg) { 
					$("<li />", { text: error.FWarningMsg }).appendTo(warnings);
					hasWarnings = true;
				}
			});
			
			if (hasErrors)
				konto.dialogs.alert({
					title: "Ispravite greške!",
					content: errors,
					root: that.$(".alerts-container")
				});
				
			if (hasWarnings) 
				konto.dialogs.alert({
					type: "alert-warning",
					title: "Upozorenja",
					content: warnings,
					root: that.$(".alerts-container")
				});
        },
        podesiFormuPremaFormParam: function(formParam, isModalForm){
            if(isModalForm){
                $('.headerTitle').addClass('Caption');  
            }
            else{
                $('.page-header-text').addClass('Caption');     
            }
            var that = this;
            $.each(formParam, function (key, val) {                             
                $obj = $('.' + val.FName);                
                if ($obj.length != 0){
                    if ($obj.hasClass('konto-checkbox-extended')){
                        $obj.setCheckboxFPProperty(val);   
                    }else{
                        //Visible
                        if (val.FIsSetVisible){
                            $obj.setVisible(val.FVisible);        
                        };
                        
                        //Enabled
                        if (val.FIsSetEnabled){                                
                            if ($obj.hasClass('list-group-item') && !val.FEnabled){
                                $obj.addClass('disabled');    
                            }else{
                                $obj.setEnabled(val.FEnabled);    
                            }         
                        }; 
                        
                        //DisplayLabel
                        if (val.FIsSetDisplayText){
                            $obj.text(val.FDisplayText);    
                        }  
                        
                        //Value
                        if (val.FIsSetValue){
							//ako negdje nađe više, npr na date objektu nađe span i input onda uzimamo samo input
							if ($obj.length > 1){
								$obj = $obj.find(':input');
							}							
                            if ($obj.hasClass("konto-input-date") || ($obj.hasClass("int-value"))) {
                                $obj.val(val.FValue);
                            }else{
                                $obj.kval(val.FValue);    
                            }    
                        }                       
                        
                        //Checked
                        if (val.FIsSetChecked){
                            $obj.setKontoChecked(val.FChecked);      
                        } 
                        
                    }
                }else if(val.FName == 'SetFocus'){  
                    that._setFocus = that.sel('.' + val.FValue);  
                }
            }); 
        }
    });
} (jQuery, window.konto = window.konto || {}));